import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/** Historical selection, shared by delivered messages and queued previews. */
export function SelectedSkillPills({ skills, className }: { skills: string[]; className?: string }) {
  const { t } = useTranslation("chat");
  if (!skills.length) return null;
  return <div role="group" aria-label={t("composerSkills.selectedGroup")} className={cn("flex w-full min-w-0 flex-wrap items-center gap-1", className)}>
    {skills.map((name) => <span key={name} className="inline-flex max-w-full min-w-0 items-center rounded-md border px-2 py-1 text-xs md:max-w-lg" title={name}><span className="truncate">{name}</span></span>)}
  </div>;
}
